import React, { useContext } from 'react';
import tw from 'twin.macro';
import { moderateComment } from 'services/comments';
import { PreferenceContext, ModerationContext } from '../context';
import { Separator } from './';
import { gaEvent } from 'services/ga';
import { Small } from '../text';
import { openExternalHref, openWindow, encodeProfileUrl } from '../../lib/helpers';
import { settings } from '../../settings';
import { notifyError } from '../notifications';
import { useUnmounted } from '../common/hooks';

const ModerationButton = ({ label, onClick }) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const isLightTheme = theme === 'light';
  return (
    <Small
      onClick={onClick}
      css={[tw`cursor-pointer text-brand`, isLightTheme && tw`text-default`]}
    >
      {label}
    </Small>
  );
};

export const EditButton = (props) => <ModerationButton {...props} />;
export const JorisButton = (props) => <ModerationButton {...props} />;
export const BanButton = (props) => <ModerationButton {...props} />;

export const ModeratorTools = ({ comment, author, authorId }) => {
  const { moderationState, setModerationState } = useContext(ModerationContext);

  const {
    id = undefined,
    report_count: reportCount,
    newComment,
  } = comment || { id: undefined, report_count: undefined };

  const commentRemoved = moderationState.removedList.includes(comment.id);
  const commentBanned = moderationState.bannedList.includes(comment.id);
  const commentHidden = moderationState.hiddenList.includes(comment.id);

  const unmounted = useUnmounted();

  return (
    <>
      {comment && comment.id && !newComment && !commentHidden && (
        <div tw='flex bg-input-back -mb-1 p-1 px-2 rounded-md w-[fit-content] opacity-80 text-xs'>
          <EditButton
            label='edit'
            onClick={() => {
              openExternalHref(`${settings.COMMENTS_HOST_URL}/admin/comments/${id}`);
            }}
          />
          <Separator />
          {!commentBanned && (
            <>
              <JorisButton
                onClick={async () => {
                  moderateComment({
                    commentId: id,
                    action: 'wegjorissen',
                  })
                    .then(() => {
                      if (!unmounted.current) {
                        setModerationState(
                          !commentRemoved
                            ? {
                                ...moderationState,
                                removedList: [...moderationState.removedList, id],
                              }
                            : {
                                ...moderationState,
                                removedList: [
                                  ...moderationState.removedList.filter((item) => item !== id),
                                ],
                              },
                        );
                      }
                      if (commentRemoved) {
                        gaEvent('dmp_comment', 'removed');
                      }
                    })
                    .catch((error) => {
                      notifyError(error);
                    });
                }}
                label={!commentRemoved ? 'wegjorissen' : 'terugjorissen'}
              />
              {!commentRemoved && <Separator />}
            </>
          )}
          {!commentRemoved && (
            <BanButton
              label={!commentBanned ? 'ban' : 'unban'}
              onClick={async () => {
                moderateComment({
                  commentId: id,
                  action: 'ban',
                })
                  .then(() => {
                    if (!unmounted.current) {
                      setModerationState(
                        !commentBanned
                          ? { ...moderationState, bannedList: [...moderationState.bannedList, id] }
                          : {
                              ...moderationState,
                              bannedList: [
                                ...moderationState.bannedList.filter((item) => item !== id),
                              ],
                            },
                      );
                    }
                    if (commentBanned) {
                      gaEvent('dmp_comment', 'ban');
                    }
                    openWindow(
                      `${settings.ADMIN_HOST_URL}/moderation/edit/${authorId}/${comment.id}`,
                    );
                  })
                  .catch((error) => {
                    notifyError(error);
                  });
              }}
            />
          )}
          {author && (
            <>
              <Separator />
              <a
                href={`/profiel/${encodeProfileUrl(author.username)}`}
                target='_blank'
                rel='noreferrer'
              >
                <BanButton label='profiel' />
              </a>
            </>
          )}
          {reportCount > 0 && (
            <>
              <Separator />
              <Small tw='text-danger font-bold'>NSB: {reportCount}</Small>
            </>
          )}
        </div>
      )}
    </>
  );
};
